// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qh-0";